/**
 * Sendet einen Page-View-Event an den Backend-Tracking-Endpoint.
 *
 * Wird nur aufgerufen wenn:
 *  - die Ziel-Route meta.requireLogin hat (eingeloggte Seiten)
 *  - von-Route und zu-Route unterschiedlich sind (kein Same-Route-Redirect)
 *  - ein Auth-Token vorhanden ist
 *
 * Fehler werden still ignoriert, damit Tracking nie den Nutzer blockiert.
 */
export function shouldTrackPageView(to, from, token) {
  if (!to.meta?.requireLogin) return false;
  if (to.name === from?.name) return false;
  if (!token) return false;
  return true;
}

export function sendPageView(routeName, path, token, baseUrl) {
  return fetch(`${baseUrl}/api/v1/page_view/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    },
    body: JSON.stringify({ route_name: routeName, path }),
  }).catch(() => {
    // Tracking-Fehler still ignorieren — nie Nutzer blockieren
  });
}
